var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-settings-advanced"},[_c('Section',[_c('div',{staticClass:"section-body"},[_c('ProjectVideoCrawlerSettings',{attrs:{"project":_vm.project}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }